import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { KYMW1300Model } from '../kymw1300.model';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";

/**
 * 商品企画マスタ画面　企画管理情報を取得するサービス
 *
 * @export GetCatalogInfoService
 * @class GetCatalogInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCatalogInfoService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1300Model}
   * @memberof GetCatalogInfoService
   */
  private model: KYMW1300Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {Object}
   * @memberof CheckRegistPlanService
   */
  private vo: {
    orderCode: '',
  };

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetCatalogInfoService
   */
  private successFunc: (model: any) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCatalogInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetCatalogInfoService
   */
  execute(model: KYMW1300Model, vo: any, successFunc: (model: any) => void): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getCatalogInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCatalogInfoService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
